// Lightweight service-worker registration for BizFinTax CRM PWA
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production" && !window.location.hostname.includes(".preview.")) {
    // Skip in local dev to avoid CRA HMR conflicts
    return;
  }
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.log("[BizFinTax PWA] service worker registered:", reg.scope);
        if (reg.waiting) reg.waiting.postMessage("SKIP_WAITING");
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              installing.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[BizFinTax PWA] SW register failed:", err);
      });
  });
}
